import { CcApprovalLevel } from "server/models"

export type CcApprovalLevelValidation = { [key in keyof CcApprovalLevel]?: string}

export interface CcModuleApprovalLevelList { [moduleId: number]: readonly number[] }
export interface CcApprovalLevelList { [levelId: number]: CcApprovalLevel }

export interface CcApprovalLevelState {
    moduleLevelList: CcModuleApprovalLevelList

    levelList: CcApprovalLevelList
    levelEdit: CcApprovalLevel

    reloadList: boolean
    reloadEdit: boolean
}

export const CC_MODULE_APPROVAL_LEVEL_LIST = "CC_MODULE_APPROVAL_LEVEL_LIST"

export const CC_APPROVAL_LEVEL_LIST = "CC_APPROVAL_LEVEL_LIST"
export const CC_APPROVAL_LEVEL_EDIT = "CC_APPROVAL_LEVEL_EDIT"

export const CC_APPROVAL_LEVEL_RELOAD_LIST = "CC_APPROVAL_LEVEL_RELOAD_LIST"
export const CC_APPROVAL_LEVEL_RELOAD_EDIT = "CC_APPROVAL_LEVEL_RELOAD_EDIT"
